import { User } from "../../../domain/User";
import { Organization } from "../../../domain/Organization";
import { LoadingIndicator } from "../LoadingIndicator/LoadingIndicator";
import { Typography } from "@optimizely/axiom";

export const UserHomeOrganizationInformation = ({
    loading = false,
    organization,
    user
}: {
    user?: User;
    organization?: Organization;
    loading?: boolean;
}) => {
    if (loading) {
        return <LoadingIndicator type="spinner" height="120px" />;
    }
    if (!(user && organization)) {
        return null;
    }

    return (
        <Typography type="body" className="push-quad--bottom">
            <div className="weight--bold">
                {user.firstName} {user.lastName}
            </div>
            <div>{user.email}</div>
            <div className="push-double--top weight--bold">Home Organization:</div>
            <div>{organization.name}</div>
        </Typography>
    );
};
